module.exports = __webpack_public_path__ + "static/img/pay_master.4f076f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order/pay_master.png
// module id = /PL4
// module chunks = 0